// removed by extract-text-webpack-plugin
module.exports = {"index":"_19Mi70xPQYznpLJQGawhnW","ins":"_2ZmFbTmKpGt0s8jdja7BMw"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/MyIcons/index.css
// module id = 141
// module chunks = 0